export default "__VITE_ASSET__DRBKXi02__"